import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../components/common-components/table/Table";
import { getInitialCurrenciesSettingsAction } from "../redux/actions/currenciesActions";

const CurrenciesDetails = () => {
    const { currenciesList, spinnerStatus, isDarkMode } = useSelector(
        (state) => state.persistedReducer,
        (oldValue, newValue) => {
            if (
                oldValue.isDarkMode !== newValue.isDarkMode ||
                oldValue.spinnerStatus !== newValue.spinnerStatus
            ) {
                return false;
            }
            return true;
        }
    );
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getInitialCurrenciesSettingsAction());
    }, [currenciesList]);
    return (
        <div className="w-full flex flex-col  items-center">
            <div
                className={` flex min-h-14 ${
                    isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                } w-full`}>
                <div className="flex-1 flex justify-center items-center text-2xl">
                    Currency Details
                </div>
                <div className="flex-5 hidden"></div>
                <div className="flex-1 hidden"></div>
            </div>
            <div className="w-11/12 h-full flex justify-center ">
                <div
                    className={`h-5/6 w-full mt-2 overflow-y-auto flex flex-col self-center  primaryScroll ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                    }`}>
                    <Table
                        data={Object.values(currenciesList).map((currency) => {
                            if (currency?.symbolInfo) {
                                const {
                                    currencyDesc,
                                    symbolInfo: {
                                        filters: {
                                            [2]: { stepSize, filterType, maxQty, minQty }
                                        }
                                    }
                                } = currency;
                                return { currencyDesc, maxQty, minQty };
                            }
                            return { currencyDesc: currency.currencyDesc, maxQty: 0, minQty: 0 };
                        })}
                        elements={{
                            parentDiv: { className: "max-h-10" },
                            tbody: { className: `` },
                            tr: {
                                className: `min-h-12 flex justify-center items-center  even:${
                                    isDarkMode ? "bg-secondaryLight " : "bg-secondaryDark "
                                } ${
                                    isDarkMode
                                        ? "even:bg-secondaryLight even:text-[#000]"
                                        : "even:bg-secondaryDark even:text-[#fff]"
                                }`
                            },
                            thead: {
                                className: `min-h-12 ${
                                    isDarkMode
                                        ? "bg-secondaryLight text-[#000] "
                                        : "bg-secondaryDark text-[#fff]"
                                } `
                            },
                            th: { className: "flex justify-center items-center" }
                        }}
                        tableHeads={["Currency Symbol", "Max Quantity", "Min Quantity"]}
                    />
                </div>
            </div>
        </div>
    );
};

export default CurrenciesDetails;
